/**
 * section-custom-packaging-references.js
 * – Animación de entrada escalonada (header + carrusel)
 * – Carrusel con flechas, dots y drag/swipe
 */

(function () {
  'use strict';

  /* ── Constantes ── */
  var STAGGER_BASE_MS = 100;   // delay base entre elementos del header
  var CARD_STAGGER_MS = 60;    // delay adicional para el bloque carrusel
  var THRESHOLD       = 0.12;
  var ROOT_MARGIN     = '0px 0px -40px 0px';

  /* ════════════════════════════════════════════
     ANIMACIONES DE ENTRADA
  ════════════════════════════════════════════ */
  function initAnimations(section) {
    var els = section.querySelectorAll('.pkg-refs__anim-el');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el    = entry.target;
        var delay = (parseInt(el.dataset.delay, 10) || 0) * STAGGER_BASE_MS;
        setTimeout(function () {
          el.style.transitionDelay = '0ms'; // reset por si acaso
          el.classList.add('is-visible');
        }, delay);
        observer.unobserve(el);
      });
    }, { threshold: THRESHOLD, rootMargin: ROOT_MARGIN });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ════════════════════════════════════════════
     CARRUSEL
  ════════════════════════════════════════════ */
  function initCarousel(section) {
    var track      = section.querySelector('.pkg-refs__track');
    var outer      = section.querySelector('.pkg-refs__track-outer');
    var btnPrev    = section.querySelector('.pkg-refs__arrow--prev');
    var btnNext    = section.querySelector('.pkg-refs__arrow--next');
    var dots       = section.querySelectorAll('.pkg-refs__dot');
    var cards      = section.querySelectorAll('.pkg-refs__card');

    if (!track || !cards.length) return;

    var currentIndex  = 0;
    var totalCards    = cards.length;
    var visibleCount  = getVisibleCount();

    /* Cuántas cards caben según ancho */
    function getVisibleCount() {
      var w = window.innerWidth;
      if (w <= 480)  return 1;
      if (w <= 768)  return 2;
      if (w <= 1100) return 3;
      return 4;
    }

    /* Índice máximo al que se puede llegar */
    function maxIndex() {
      return Math.max(0, totalCards - visibleCount);
    }

    /* Mueve el track al índice dado */
    function goTo(index) {
      index = Math.max(0, Math.min(index, maxIndex()));
      currentIndex = index;

      /* Calcula offset: ancho de card + gap */
      var card      = cards[0];
      var cardW     = card.getBoundingClientRect().width;
      var gap       = parseFloat(getComputedStyle(track).gap) || 24;
      var offset    = index * (cardW + gap);

      track.style.transform = 'translateX(-' + offset + 'px)';

      /* Actualiza dots */
      dots.forEach(function (d, i) {
        d.classList.toggle('pkg-refs__dot--active', i === index);
        d.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      /* Actualiza estado de flechas */
      if (btnPrev) btnPrev.disabled = index === 0;
      if (btnNext) btnNext.disabled = index >= maxIndex();
    }

    /* Flechas */
    if (btnPrev) {
      btnPrev.addEventListener('click', function () { goTo(currentIndex - 1); });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function () { goTo(currentIndex + 1); });
    }

    /* Dots */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.dotIndex, 10));
      });
    });

    /* ── Drag / Swipe ── */
    var dragStart  = null;
    var dragOffset = 0;
    var isDragging = false;

    function onDragStart(x) {
      dragStart  = x;
      dragOffset = 0;
      isDragging = false;
      track.classList.remove('is-dragging');
    }

    function onDragMove(x) {
      if (dragStart === null) return;
      dragOffset = x - dragStart;
      if (Math.abs(dragOffset) > 6) {
        isDragging = true;
        track.classList.add('is-dragging');
      }
    }

    function onDragEnd() {
      if (!isDragging) { dragStart = null; return; }
      var threshold = 60;
      if (dragOffset < -threshold) goTo(currentIndex + 1);
      else if (dragOffset > threshold) goTo(currentIndex - 1);
      dragStart  = null;
      dragOffset = 0;
      isDragging = false;
      track.classList.remove('is-dragging');
    }

    /* Mouse */
    track.addEventListener('mousedown',  function (e) { onDragStart(e.clientX); });
    window.addEventListener('mousemove', function (e) { onDragMove(e.clientX); });
    window.addEventListener('mouseup',   function ()  { onDragEnd(); });

    /* Touch */
    track.addEventListener('touchstart', function (e) { onDragStart(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchmove',  function (e) { onDragMove(e.touches[0].clientX); },  { passive: true });
    track.addEventListener('touchend',   function ()  { onDragEnd(); });

    /* Evitar navegación accidental al hacer drag */
    track.addEventListener('click', function (e) {
      if (isDragging) e.preventDefault();
    }, true);

    /* Responsive: recalcula al redimensionar */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        visibleCount = getVisibleCount();
        goTo(Math.min(currentIndex, maxIndex()));
      }, 150);
    });

    /* Estado inicial */
    goTo(0);
  }

  /* ════════════════════════════════════════════
     INICIALIZACIÓN
  ════════════════════════════════════════════ */
  function initSection(section) {
    initAnimations(section);
    initCarousel(section);
  }

  function init() {
    document
      .querySelectorAll('.section-custom-packaging-references')
      .forEach(initSection);
  }

  /* Soporte Shopify Theme Editor */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.section-custom-packaging-references');
    if (section) initSection(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
